<!-- using ngIf here to purge the form state on the dialog when it's closed -->
<app-add-auto-archiving-questions-dialog
    *ngIf="showDialog"
    [open]="showDialog"
    (closing)="showDialog = false"
    (questionAdded)="onQuestionAdded($event)"
    (questionEdited)="onQuestionEdited($event)"
    [question]="dialogMode === 'edit' ? questionToEdit : null"
    [mode]="dialogMode"
    [jobPosting]="jobPosting"
></app-add-auto-archiving-questions-dialog>

<app-previous-question-dialog
    *ngIf="isPreviousAutoArchivingQuestionDialogOpen"
    [openDialog]="isPreviousAutoArchivingQuestionDialogOpen"
    [isAutoArchive]="true"
    [jobPosting]="jobPosting"
    header="{{
        'applicant-tracker.components.auto-archiving-questions.previouslyUsedAutoArchivingQuestions' | translate
    }}"
    (onClose)="closePreviousAutoArchivingQuestionDialog()"
    (questionsAdded)="onPreviouslyQuestionAdded($event)"
></app-previous-question-dialog>

<ui-dialog
    size="small"
    header="{{ 'applicant-tracker.components.auto-archiving-questions.deleteQuestion' | translate }}"
    [open]="isDeleteDialogOpen"
    deleteDialog
    (primaryButtonPressed)="onDelete()"
    (secondaryButtonPressed)="closeDeleteDialog()"
    (closing)="isDeleteDialogOpen = false"
    primaryButtonLabel="{{ 'delete' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
>
    <p>{{ 'applicant-tracker.components.auto-archiving-questions.areYouSureYouWantToDelete' | translate }}</p>
</ui-dialog>

<ui-card role="group" aria-labelledby="auto-archiving-questions-header" [loading]="isLoading">
    <div class="margin-bottom-3">
        <div class="flex justify-space-between">
            <h2 id="auto-archiving-questions-header">
                {{ 'applicant-tracker.components.auto-archiving-questions.autoArchivingQuestions' | translate }}
            </h2>
            <ui-button
                [attr.data-cy]="'autoArchivingQuestionButton'"
                type="outline"
                [matMenu]="autoArchivingDropdown"
                (click)="dialogMode = 'add'"
            >
                {{ 'applicant-tracker.components.auto-archiving-questions.addQuestion' | translate }}
                <mat-icon svgIcon="chevronDown"></mat-icon
            ></ui-button>
        </div>
        <p class="margin-bottom-3">
            {{ 'applicant-tracker.components.auto-archiving-questions.humiWillAutomatically' | translate }}
        </p>
    </div>

    <app-simple-table
        [showMeatballs]="true"
        [attr.data-cy]="'autoArchivingQuestionSimpleTable'"
        *ngIf="rows?.length > 0"
        [columns]="columns"
        [rows]="rows"
        (editClicked)="onEdit($event)"
        (deleteClicked)="openDeleteDialog($event)"
    ></app-simple-table>
</ui-card>

<!-- Mat menu -->
<mat-menu #autoArchivingDropdown>
    <button mat-menu-item (click)="showDialog = true">
        {{ 'applicant-tracker.components.auto-archiving-questions.fromScratch' | translate }}
    </button>
    <button mat-menu-item (click)="openPreviousAdditionalQuestionDialog()">
        {{ 'applicant-tracker.components.auto-archiving-questions.fromPrevious' | translate }}
    </button>
</mat-menu>
